module.exports = __webpack_public_path__ + "media/Pasttime in the Camp.6c6d0cab.mp3";